import { render, staticRenderFns } from "./VersionAndroid.vue?vue&type=template&id=4aff256d&scoped=true"
import script from "./VersionAndroid.vue?vue&type=script&lang=js"
export * from "./VersionAndroid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aff256d",
  null
  
)

export default component.exports